module.exports = "/_next/static/images/3-95310dd466817052ee5fe3a6314523b9.gif";